import { MultiSelectCards } from '../../../components/quiz';
import type { SelectableCardOption } from '../../../types';

interface DebtStepProps {
  hasDebt: boolean | null;
  debtTypes?: string[];
  isBusinessDebt?: boolean;
  onHasDebtChange: (hasDebt: boolean) => void;
  onDebtTypesChange?: (types: string[]) => void;
}

const BUSINESS_DEBT_OPTIONS: SelectableCardOption[] = [
  { id: 'credit_card', icon: '💳', title: 'Credit Card' },
  { id: 'car_loan', icon: '🚗', title: 'Car Loan' },
  { id: 'business_loan', icon: '🏦', title: 'Business Loan' },
  { id: 'credit_line', icon: '📄', title: 'Credit Line' },
  { id: 'other', icon: '📋', title: 'Other' },
];

const CONSUMER_DEBT_OPTIONS: SelectableCardOption[] = [
  { id: 'credit_card', icon: '💳', title: 'Credit Cards' },
  { id: 'student_loans', icon: '🎓', title: 'Student Loans' },
  { id: 'car_loan', icon: '🚗', title: 'Car Loan' },
  { id: 'personal_loan', icon: '💵', title: 'Personal Loan' },
  { id: 'mortgage', icon: '🏠', title: 'Mortgage' },
  { id: 'medical', icon: '🏥', title: 'Medical Debt' },
  { id: 'other', icon: '📋', title: 'Other' },
];

export default function DebtStep({
  hasDebt,
  debtTypes = [],
  isBusinessDebt = false,
  onHasDebtChange,
  onDebtTypesChange,
}: DebtStepProps) {
  const debtOptions = isBusinessDebt ? BUSINESS_DEBT_OPTIONS : CONSUMER_DEBT_OPTIONS;

  return (
    <div className="quiz-step">
      <div className="quiz-step__header">
        <h2 className="quiz-step__question">
          {isBusinessDebt ? 'Is your business carrying any debt?' : 'Are you carrying any debt right now?'}
        </h2>
        <p className="quiz-step__helper">No judgment - we'll find the fastest way out</p>
      </div>

      <div className="quiz-step__body">
        <div className="single-select-grid wide-select-grid">
          <button
            type="button"
            className={`selectable-card selectable-card--compact ${hasDebt === true ? 'selectable-card--selected' : ''}`}
            onClick={() => onHasDebtChange(true)}
          >
            <div className="selectable-card__content">
              <span className="selectable-card__title">Yes</span>
            </div>
            <span className="selectable-card__indicator" aria-hidden="true" />
          </button>

          <button
            type="button"
            className={`selectable-card selectable-card--compact ${hasDebt === false ? 'selectable-card--selected' : ''}`}
            onClick={() => onHasDebtChange(false)}
          >
            <div className="selectable-card__content">
              <span className="selectable-card__title">No</span>
            </div>
            <span className="selectable-card__indicator" aria-hidden="true" />
          </button>
        </div>

        {hasDebt === true && onDebtTypesChange && (
          <div style={{ marginTop: 'var(--space-6)' }}>
            <p style={{ fontSize: 'var(--font-size-sm)', color: 'var(--color-text-secondary)', marginBottom: 'var(--space-3)', textAlign: 'center' }}>
              What types of debt do you have?
            </p>
            <MultiSelectCards
              options={debtOptions}
              value={debtTypes}
              onChange={onDebtTypesChange}
            />
          </div>
        )}
      </div>
    </div>
  );
}
